import { inject, Injectable } from '@angular/core';
import { HttpClient, httpResource } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EventDTO } from '../models/event.model';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  PATH = '/api/events';
  private http = inject(HttpClient);

  readonly eventsResource = httpResource<EventDTO[]>(
    () => this.PATH,
    {
      parse: (events) =>
        [...(events as EventDTO[])].sort(
          (a, b) =>
            new Date(b.date).getTime() - new Date(a.date).getTime()
        )
    }
  );

  getEvent(id: number): Observable<EventDTO> {
    return this.http.get<EventDTO>(`${this.PATH}/${id}`);
  }

  updateEvent(eventData: EventDTO) {
    return this.http.put(`${this.PATH}`, eventData);
  }

  createEvent(eventData: EventDTO) {
    return this.http.post(`${this.PATH}`, eventData);
  }

  deleteEvent(id: number) {
    return this.http.delete(`${this.PATH}/${id}`);
  }

  refreshEvents(): void {
    this.eventsResource.reload();
  }
}

